import React, { Component, PropTypes } from 'react'
import { browserHistory } from 'react-router'
import Dialog from '../dialog'
import { Button } from '../ui'

function redirectToSignIn() {
    browserHistory.push('/sign-in')
}

export default class SignOut extends Component {
    static displayName = 'SignOut'

    static propTypes = {
        actions: PropTypes.shape({
            signOut: PropTypes.func.isRequired,
        }).isRequired,
    }

    componentWillMount() {
        this.props.actions.signOut()
    }

    render() {
        const header = (
            <div className="logo">
                <img alt="" src="/img/hayden-logo.png" width="200" />
            </div>
        )

        return (
            <Dialog allowClose={ false } background={ false } header={ header } open size="small">
                <h4 className="align-center">See you soon</h4>
                <Button
                    fullWidth
                    onClick={ redirectToSignIn }
                    status={ 'primary' }
                >
                    Sign in again
                </Button>
            </Dialog>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/account/sign_out.js